<template>
	<div class="my-table menuManagementPage">
		<!-- 面包屑组件 -->
		<div class="searchBox relative">
			<div class="current-location">
				<img class="location" src="@/assets/picture/icon/location.png">
				<span>{{$t('menuManagement.txt1')}}</span>
				<span>{{$t('menuManagement.txt2')}} / {{$t('menuManagement.txt3')}}</span>
			</div>
		</div>
		<!-- 面包屑 -->
		<el-card class="tableCard p30 mt0">
			<div class=" flexCenterBtn">
				<Tag></Tag>
				<div class="flexEndBtn">
					<div class="searchBtn ml20" @click="handleAddMenu">{{$t('menuManagement.txt4')}}</div>
				</div>
			</div>
			<el-table :data="dataList" row-key="id" v-loading="loading" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column :label="$t('menuManagement.txt5')" width="250">
					<template slot-scope="scope">
						<span>{{scope.row.name?scope.row.name:'--'}}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('menuManagement.txt6')">
					<template slot-scope="scope">
						<span>{{scope.row.menuUrl?scope.row.menuUrl:'--'}}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column label="父级菜单">
					<template slot-scope="scope">
						<span>{{scope.row.parentId?scope.row.parentId:'--'}}</span>
					</template>
				</el-table-column> -->
				<el-table-column :label="$t('menuManagement.txt7')" width="300">
					<template slot-scope="scope">
						<span>{{getMenuTypeText(scope.row.menuType)}}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('menuManagement.txt8')" width="150">
					<template slot-scope="scope">
                        <img v-if="scope.row.menuIcon" height="30" :src="serverUrl + '/'+ scope.row.menuIcon" alt="">
					</template>
				</el-table-column>
				<el-table-column :label="$t('menuManagement.txt9')" width="240">
					<template slot-scope="scope">
						<div>
							<el-button @click="handleEditMenu(scope.row)" class="handleBtn" type="text">{{$t('menuManagement.txt10')}}</el-button>
							<el-button @click="handleDelete(scope.row.id)" class="handleBtn" type="text">{{$t('menuManagement.txt11')}}</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<!-- <div class="table-footer">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="queryInfo.pageNum" :page-sizes="[100, 200, 300, 400]" :page-size="queryInfo.pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div> -->
		</el-card>
	</div>
</template>

<script>
import { formatDate } from "@/plugins/date.js";
import Tag from './components/tag.vue';
import {apiUrl, serverUrl} from '@/utils/request';
import qs from "qs";
import menuMixin from './menuMixin';
export default {
	mixins: [menuMixin],
	components: {
			Tag
		},
	data() {
		return {
            serverUrl,
			isIndeterminate: true,
			time: "",
			editMenuRules: {},
			menuTypes:[
				{ label: this.$t('menuManagement.txt12'), value: '1' },
				{ label: this.$t('menuManagement.txt13'), value: '2' },
				{ label: this.$t('menuManagement.txt14'), value: '3' },
			],
			//用于获取数据列表
			queryInfo: {
				cmptName: "",
				endCreateTm: "",
				pageNum: 1,
				pageSize: 10,
				productTmplCmptId: "",
				projName: "",
				spvTm: "",
				startCreateTm: "",
				submitterName: "",
				witnCde: "",
				witnType: "",
			},
            menuTree: [],
			dataList: [],
			total: 0,
            loading: false,
		};
	},
	created() {
        this.getMenuTree();
	},
	filters: {
		formatDate(time) {
			var date = new Date(time);
			return formatDate(date, "yyyy-MM-dd");
		},
	},
	methods: {
        getMenuTypeText(type) {
            if(!type) return ''
            return this.menuTypes.find(item => item.value == type).label
        },
		// 获取用户菜单
		async loadData() {
			this.getMenuTree();
		},
        async getMenuTree() {
            this.loading = true
			const { data: res } = await this.$http.post("/menu/getMenuTree");
            this.loading = false;
			if (!res.success) {
				return this.$message.error(res.message);
			}
			this.dataList = JSON.parse(JSON.stringify(res.result))
			// 语言包todo
            res.result.unshift({
                name: this.$t('menuManagement.txt15'),
                id: '0',
            })
            each(res.result)
            function each(list) {
                list.forEach(item =>{
                    if(!item.parentId) {
                        item.parentId = '0'
                    }
                    if(item.children && item.children.length == 0) {
                        delete(item.children)
                    }
                    else {
                        item.children && each(item.children)
                    }
                })
            }
			this.menuTree = res.result;
        },
		// 返回上一页
		returnPage() {
			this.$router.go(-1);
		},
		// 新增菜单
		handleAddMenu() {
			this.$router.push({path: "/editMenu"});
		},
		// 修改菜单
		handleEditMenu(row) {
			this.$router.push({path: '/editMenu', query: {id: row.id}});
		},
		
		// 页面切换
		handleCurrentChange(pageNum) {
			this.queryInfo.pageNum = pageNum;
			this.loadData();
		},
		handleSizeChange(pageSize) {
			this.queryInfo.pageSize = pageSize;
			this.loadData();
		},
		
		// 删除
		async handleDelete(id) {
			this.$confirm(
				'<p class="color666 fz14">'+this.$t('menuManagement.txt16')+'</p><p class="color999 fz14">'+this.$t('menuManagement.txt17')+'</p>',
				"删除",
				{
					dangerouslyUseHTMLString: true,
					confirmButtonText: this.$t('menuManagement.txt18'),
					cancelButtonText: this.$t('menuManagement.txt19'),
					type: "warning",
					center: true,
				}
			)
				.then(async () => {
					const { data: res } = await this.$http.post("/menu/delete?id=" + id);
                    if (!res.success) {
                        return this.$message.error(res.message);
                    }
                    this.$message.success(this.$t('menuManagement.txt20'))
                    this.loadData()
                    this.getMenuTree()
				})
				.catch(() => {
                  
				});
		},
	},
};
</script>

<style lang="less" scoped>
.menuManagementPage {
	/deep/ .checkbox,
	.form-control,
	/deep/ .radio,
	input[type="file"],
	output {
		display: none;
	}

	.back {
		display: inline-block;
		margin-right: 2.6rem;

		img {
			width: 1.8rem;
			height: 1.8rem;
			margin-right: 0.7rem;
		}

		span {
			font-size: 1.6rem;
			font-weight: 400;
			color: #333333;
		}
	}

	.tips:first-of-type {
		padding-top: 2rem;
	}

	.tips {
		font-size: 1.2rem !important;
        line-height: 2;
		color: #999 !important;
	}

	.w32 {
		/deep/ .el-input,
		/deep/ .el-input__inner {
			width: 100% !important;
		}
	}

	.mb15 {
		margin-bottom: 1.5rem;
	}

	.searchBox {
		/*width: 33.6rem !important;*/
		height: 3.2rem;

		.btnC {
			padding: 0.6rem 2.6rem;
		}
	}

	/deep/ .el-transfer__button:first-of-type {
		display: none;
	}

	/deep/ .el-button--primary {
		width: auto;
		height: auto;
		padding: 0;
		background: none;
	}

	/deep/ .el-button--primary.is-disabled {
		background: none;
		border: none;
	}

	/deep/ .el-transfer-panel {
		border: 1px solid #c0c0c0;
		border-radius: 6px;
		width: 46%;
		margin-right: 0.8rem;
	}

	/deep/ .el-transfer-panel:last-of-type {
		margin-left: 0.8rem;
		margin-right: 0rem;
	}

	/deep/ .el-transfer-panel .el-transfer-panel__header {
		background: #eeeeee;
		font-size: 1.4rem;
		font-weight: bold;
		color: #1b3b7c;
	}

	/deep/
		.el-transfer-panel
		.el-transfer-panel__header
		.el-checkbox
		.el-checkbox__label {
		font-size: 1.4rem;
		font-weight: bold;
		color: #1b3b7c;
	}

	/deep/ .el-button + .el-button {
		margin-left: 0 !important;
	}

	/deep/ .el-transfer__buttons {
		padding: 0;
	}

	.tips {
		font-size: 1.4rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #98b9ff;
		margin-top: -10px;
	}

	/deep/ .el-dialog {
		/deep/ .el-input,
		/deep/ .el-input__inner {
			width: 100% !important;
		}

		.el-select {
			width: 100%;
		}

		/deep/ .el-dialog .el-dialog__body .el-form-item__label {
			color: #666;
		}

		/deep/ .el-dialog .el-dialog__body .el-select .el-input__inner,
		.el-dialog .el-dialog__body .el-input__inner,
		.el-dialog .el-dialog__body .el-input {
			border-radius: 8px;
		}
	}
}
	.handleBtn{
		padding: 0;
	}

	/deep/.el-upload__input{
		opacity: 0;
	}
</style>
